import React from "react"
import { CurtainsProvider } from "./components/curtains"

/**
 * Wraps every route so the shutter overlay persists across navigations.
 */
export const wrapPageElement = ({ element }) => (
  <CurtainsProvider>{element}</CurtainsProvider>
)
